import React, { useEffect, useRef } from 'react';
import '../styles/cta.css';

const CTABanner = () => {
  const bannerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (bannerRef.current) observer.observe(bannerRef.current);
    return () => {
      if (bannerRef.current) observer.unobserve(bannerRef.current);
    };
  }, []);

  return (
    <section className="cta-section">
      <div className="container">
        <div className="cta-banner" ref={bannerRef}>
          <h2>Ready to take the first step?</h2>
          <p>Book a consultation with one of our specialists today.</p>
          <a
            href="https://book.healthplix.com/dr-doctor-s-name-specialisation-place-city_198213"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Get started with us
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;